import { FC, useState } from 'react';

import { FlexContentRegion, FullHeightFlexColumn } from '@/shared';
import { ReportComponent } from '@/types';

import Header from './layout/01-Header';
import Content from './layout/02-Content';
import Footer from './layout/03-Footer';

export enum ResultsView {
    CHART = 'Chart',
    TABLE = 'Table',
    JSON = 'JSON',
    SQL = 'SQL',
}

interface PreviewProps {
    component: ReportComponent;
}

const Preview: FC<PreviewProps> = ({ component }): JSX.Element => {
    const [segmented, setSegmented] = useState(ResultsView.CHART);

    return (
        <FullHeightFlexColumn>
            <Header component={component} />
            <FlexContentRegion>
                <Content component={component} segmented={segmented} />
            </FlexContentRegion>
            <Footer component={component} setSegmented={setSegmented} />
        </FullHeightFlexColumn>
    );
};

export default Preview;
